import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FileSaverService } from '../common/file/file-saver.service';
import { FileSaverUsecase } from '../../domain/model/file-saver-usecase.enum';
import { AbstractCsvExportService } from '../utils/abstract-csv-export.service';
import { NetzbetreiberTeilgebieteInfo } from '../auth/netzbetreiber-teilgebiete-info';


@Injectable({
    providedIn: 'root',
})
export class ErzeugungsanlageExportService extends AbstractCsvExportService {

    constructor() {
        super(inject(HttpClient), inject(FileSaverService));
    }

    public exportErzeugungsanlagen(
        stadtwerkeId?: string,
        teilgebiet?: string,
        isWestnetz: boolean = true,
        completed: () => void = () => {},
    ) {
        let params = new HttpParams();

        if (stadtwerkeId) {
            params = params.set('stadtwerkeId', stadtwerkeId);
        }

        const httpOptions = {
            headers: new HttpHeaders({
                'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
            params: params,
        };

        this.http.get(environment.API_URL + '/erzeugungsanlage/erzeugungsanlagen.xlsx', {
            ...httpOptions,
            responseType: 'blob',
        }).subscribe({
            next: (file) => {
                if (isWestnetz) {
                    this.fileSaverService.saveFileByUsecaseAsWestnetz(
                        FileSaverUsecase.EXCEL_EXPORT_ERZEUGUNGSANLAGEN,
                        file,
                        stadtwerkeId,
                    );
                } else {
                    this.fileSaverService.saveFileByUsecaseAsNvnb(
                        FileSaverUsecase.EXCEL_EXPORT_ERZEUGUNGSANLAGEN,
                        file,
                        teilgebiet,
                    );
                }
            },
            error: () => {
            },
            complete: completed,
        });
    }

    public exportErzeugungsanlagenCSV(teilgebiet?: NetzbetreiberTeilgebieteInfo) {
        this.exportCsv(
            '/erzeugungsanlage/erzeugungsanlagen.csv',
            FileSaverUsecase.CSV_EXPORT_ERZEUGUNGSANLAGEN,
            teilgebiet,
        );
    }
}



